import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SharedAccessLinkCard from './SharedAccessLinkCard';

const SharedAccessLinksList = ({ links = [], onEdit, onDelete, onDeactivate, onViewLogs, onCopyUrl }) => {
  // Ensure links is always an array
  const linksArray = Array.isArray(links) ? links : [];
  
  if (!linksArray || linksArray.length === 0) {
    return null;
  }

  return (
    <Row>
      {linksArray.map((link) => (
        <Col xs={12} key={link.id} className='mb-3'>
          <SharedAccessLinkCard
            link={link}
            onEdit={onEdit}
            onDelete={onDelete}
            onDeactivate={onDeactivate}
            onViewLogs={onViewLogs}
            onCopyUrl={onCopyUrl}
          />
        </Col>
      ))}
    </Row>
  );
};

export default SharedAccessLinksList;

